<div>
  <label>
    <input
      type="checkbox"
      class="me-3 form-check-input"
      [formControl]="control"
      (click)="onCheckboxClicked()"
      appSaveLastFocussedConditionally [saveLastFocussedEnabled]="saveLastFocusedEnabled"
      [ngbPopover]="assistantServiceEnabled ? popOver : null"/>
    <ng-content select=".app-label"/>
    <ng-template #popOver>
      <app-assistant (assistantDisabled)="disableAssistant()">
        <ng-content select=".assistant-text"></ng-content>
      </app-assistant>
    </ng-template>
  </label>
</div>
